<style>
#hydrantsRegisterModal .v--modal-box.v--modal {
  min-height: 410px !important;
  min-width: 650px !important;
}
#hydrantsRegisterModal .modal__content {
  overflow-y: hidden !important;
}
#hydrantsRegisterModal .modal__footer {
  display: none;
}
</style>

<template>
  <Modal
    modalName="hydrantsRegisterModal"
    title="REJESTR HYDRANTÓW"
    :buttons="[]"
    :register="register"
  >
    <HydrantsTable />
  </Modal>
</template>

<script>
import Modal from "../../../../shared/Modal";
import HydrantsTable from "../../../table/HydrantsTable";

export default {
  components: {
    Modal,
    HydrantsTable
  },
  data: () => ({
    register: true
  }),
  computed: {},
  methods: {}
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/hydrants/modals/hydrants/HydrantsRegister.vue